import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { formControlElement, formLabelElement } from 'src/app/animations/animations';
import { P30APIService } from 'src/app/core/services/api';
import { SessionStorageService } from 'src/app/core/services/session_storage';
import { API_FAILING_ERROR_MESSAGE, PROPOSAL_ID } from 'src/app/constants/constants';
import { NzCarouselComponent } from 'ng-zorro-antd/carousel';
import { DataService } from 'src/app/core/services/data_service';
import { LegalEntity } from 'src/app/core/interfaces/LegalEntities';
import { NzMessageService } from 'ng-zorro-antd/message';
import { DataServiceEntitySelection } from 'src/app/core/services/data_service_entity_selection';
import { MaxWordLimit } from 'src/app/constants/constants';

@Component({
    selector: 'app-acquisition-entity-selection',
    templateUrl: './acquisition-entity-selection.component.html',
    styleUrls: ['./acquisition-entity-selection.component.less'],
    animations: [formControlElement, formLabelElement],
    standalone: false
})
export class AcquisitionEntitySelectionComponent{
  @Output() isLoader = new EventEmitter<boolean>;
  componentIsVisible:boolean =false;
  legalEntityForm!: UntypedFormGroup;
  nzLoading:boolean = false;
  nzSearchValue!:string;
  @Input() acquisitionEntitySelectionForm!: UntypedFormGroup;
  legalEntities: LegalEntity[] = [{
    companyName: "NA"
  }];
  current = 0;
  wordLimit = MaxWordLimit;
  selectedLegalEntities: LegalEntity[] = [];
  showComments:boolean = false;
  selectedEntity: string[] =[];
  apiErrorMSG: string = API_FAILING_ERROR_MESSAGE;

  @ViewChild('carouselLegalEntity')
  carouselLegalEntity!: NzCarouselComponent;
  constructor(private fb: UntypedFormBuilder, private apiService: P30APIService, private session: SessionStorageService, private message:NzMessageService ,
    private dataservice: DataService,
    private entitySelectionDataService: DataServiceEntitySelection){
  }

  async ngOnInit(){
    if(this.dataservice.legalEntities.length > 0){
      this.legalEntities = [...this.dataservice.legalEntities];
    }
    if(this.dataservice.selectedLegalEntities.length > 0){
      this.selectedLegalEntities = [...this.dataservice.selectedLegalEntities];
    }

    if(this.acquisitionEntitySelectionForm.controls["legalEntity"].value == "NA"){
      this.showComments = true;
    } else {
      await this.getLegalEntities();

      if(this.legalEntitiesFormArray.length > 0){
        for(let i = 0; i < this.legalEntitiesFormArray.length; i++){
          const companyName = this.legalEntitiesFormArray.at(i).value.companyName;
          if(companyName && !this.selectedEntity.includes(companyName)){
            this.selectedEntity.push(companyName);
          }
        }
      } else if(this.selectedLegalEntities.length > 0){
        this.legalEntities = [...this.selectedLegalEntities];
        this.legalEntities.unshift({ companyName: "NA" });
        for(const entity of this.selectedLegalEntities){
          if(entity.companyName && entity.companyName !== "NA"){
            this.selectedEntity.push(entity.companyName);
            this.addField(entity.companyName);
          }
        }
      }

      this.legalEntities = [...this.selectedLegalEntities];
      this.legalEntities.unshift({ companyName: "NA" });
    }
  }
  ngOnDestroy(){
    this.dataservice.legalEntities = [...this.legalEntities];
    this.dataservice.selectedLegalEntities = [...this.selectedLegalEntities];
  }

  get legalEntitiesFormArray(){
    return this.acquisitionEntitySelectionForm.controls["legalEntitiesFormArray"] as FormArray;
  }

  onSearch(){
    this.legalEntities = [{
        companyName: "NA"
      }];
    if(this.nzSearchValue){
      this.nzLoading = true;
      this.apiService.getCompanies(this.nzSearchValue).subscribe({
        next: (event) =>{
          let arrResult = [];
          arrResult = [...event.body.companies];
          arrResult.forEach(element => {
            let legalEntity:LegalEntity = {
              ccn: element.companyCodeNumber,
              companyName: element.companyName,
              jurisdiction: element.countryName
            }
            this.legalEntities.push(legalEntity);
          });
        },
        error: (err)=>{
          this.message.error(this.apiErrorMSG);
          this.nzLoading = false;
        },
        complete: () =>{
          this.nzLoading = false;
        }
      });
    }
  }

  onSearchEvent(event:string){
    this.nzSearchValue = event;
  }

  async onChange(event:string){
    if(event === null || event === undefined) return;
    if(event==='NA'){
      this.removeFormArray();
      this.selectedEntity = [];
      await this.onChangeGetLegalEntities(false);
      this.showComments = true;
      this.selectedLegalEntities = [];
      const control = this.acquisitionEntitySelectionForm.controls["comments"]
      control.setValidators([Validators.required]);
      control.updateValueAndValidity();
    }else{
      if(!this.selectedEntity.includes(event)){
        this.isLoader.emit(true);
        await new Promise<void>((resolve, reject) => {
          this.apiService.getCompanyDetails(this.legalEntities.find(data=>data.companyName===event)?.ccn).subscribe({
            next: (output) =>{
              if(output.body){
                const modifiedLegalEntities = this.legalEntities.map(obj => {
                  if (obj.ccn === output.body.companyCodeNumber) {
                    return { ...obj, ownershipDetail: output.body.ownership };
                  }
                  return obj;
                });
                this.legalEntities = [...modifiedLegalEntities];
              }
            },
            error: (err)=>{
              this.message.error(this.apiErrorMSG);
              this.isLoader.emit(false);
              reject(err);
            },
            complete: () =>{
              this.addField(event);
              this.selectedEntity.push(event);
              const addedEntity = this.legalEntities.find(data => data.companyName === event);
              if(addedEntity && !this.selectedLegalEntities.find(e => e.companyName === event)){
                this.selectedLegalEntities.push(addedEntity);
              }
              this.isLoader.emit(false);
              this.acquisitionEntitySelectionForm.controls["legalEntity"].setValue(null, { emitEvent: false });
              this.legalEntities = [{ companyName: "NA" }];
              this.nzSearchValue = '';
              resolve();
            }
          });
        });
      }
      this.showComments=false;
      const control = this.acquisitionEntitySelectionForm.controls["comments"]
      control.removeValidators([Validators.required]);
      control.setValue(null);
      control.updateValueAndValidity();
    }
  }

  async onChangeGetLegalEntities(isNa: boolean): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.entitySelectionDataService.getLegalEntities().subscribe({
        next: (event) => {
          const deletePromises: Promise<void>[] = [];
          if (event.body && event.body.length > 0) {
            const dbEntities = [...event.body];
            dbEntities.forEach(findItem => {
              if (!findItem.legalEntityId) return;
              if (isNa) {
                const keepEntity = this.selectedEntity.includes(findItem.companyName);
                if (!keepEntity) {
                  deletePromises.push(this.deleteLegalEntityAsync(findItem.legalEntityId));
                }
              } else {
                if (findItem.companyName !== "NA") {
                  deletePromises.push(this.deleteLegalEntityAsync(findItem.legalEntityId));
                }
              }
            });
          }
          if (deletePromises.length > 0) {
            Promise.all(deletePromises).then(() => resolve()).catch(reject);
          } else {
            resolve();
          }
        },
        error: (err) => {
          this.message.error(this.apiErrorMSG);
          reject(err);
        }
      });
    });
  }

  deleteLegalEntityAsync(legalEntityId: any): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.apiService.deleteLegalEntity(this.session.getItem(PROPOSAL_ID), legalEntityId).subscribe({
        next: () => {},
        error: (err) => {
          this.message.error(this.apiErrorMSG);
          console.error("Unable to delete legal entity record", err);
          reject(err);
        },
        complete: () => resolve()
      });
    });
  }

  addField(value:string) {
    const source = this.legalEntities.find(data => data.companyName === value)
                ?? this.selectedLegalEntities.find(data => data.companyName === value);
    if (!source) return;
    const legalEntityForm = this.fb.group({
      legalEntityId: [source.legalEntityId],
      legalEntityName:[value],
      ccn:[source.ccn],
      companyName:[value],
      jurisdiction:[source.jurisdiction],
      ownershipDetail:[source.ownershipDetail],
      legalEntityComments: [null],
      typeofLegalEntity: ['Acquisition'],
    })
    this.legalEntitiesFormArray.push(legalEntityForm);
  }

  removeFormArray(){
    this.legalEntitiesFormArray.clear();
  }

  deleteLegalEntity(legalEntityId:any){
    this.isLoader.emit(true);
      this.apiService.deleteLegalEntity(this.session.getItem(PROPOSAL_ID), legalEntityId).subscribe({
        next: (out) =>{

        },
        error: (err) =>{
          this.message.error(this.apiErrorMSG);
          console.log("Unable to create legal entity record in the database table ",err);
          this.isLoader.emit(false);
        },
        complete: () => {
          this.isLoader.emit(false);
        }
      })
  }

  async onCloseTag(event:string){
    let index = this.selectedEntity.indexOf(event);
    this.selectedEntity.splice(index, 1);
    let findItem = this.selectedLegalEntities.find(e => e.companyName === event);
    const formItem = this.legalEntitiesFormArray.value.find((e: any) => e.companyName === event);
    const legalEntityId = findItem?.legalEntityId ?? formItem?.legalEntityId;
    if(legalEntityId){
      await this.deleteLegalEntityAsync(legalEntityId);
    }
    const slIndex = this.selectedLegalEntities.findIndex(e => e.companyName === event);
    if(slIndex !== -1) this.selectedLegalEntities.splice(slIndex, 1);
    this.removeFormArray();
    for(let entityName of this.selectedEntity){
      this.addField(entityName);
    }
  }

  getLegalEntities(): Promise<boolean> {
    return new Promise<boolean> ((resolved)=>{
      if(this.session.getItem(PROPOSAL_ID)){
        this.isLoader.emit(true);
        this.entitySelectionDataService.getLegalEntities().subscribe({
          next: (event) =>{
            this.selectedLegalEntities =[];
            if(event.body){
              for(const element of event.body){
                let leglaEntity: LegalEntity = {
                  legalEntityId: element.legalEntityId,
                  ccn: element.ccn,
                  companyName: element.companyName,
                  jurisdiction: element.jurisdiction,
                  ownershipDetail: element.ownershipDetail,
                  legalEntityComments: element.legalEntityComments,
                  typeofLegalEntity: element.typeofLegalEntity
                }
                this.selectedLegalEntities.push(leglaEntity);
              }
            }
          },
          error: (err) =>{
            this.message.error(this.apiErrorMSG);
            console.log("Unable to get legal entity record in the database table ",err);
            this.isLoader.emit(false);
            resolved(false);
          },
          complete: () =>{
            this.isLoader.emit(false);
            resolved(true);
          }
        });
      }
    });
  }

  nextSlide(){
    this.carouselLegalEntity.next();
    this.current++;
  }

  prevSlide(){
    this.carouselLegalEntity.pre();
    this.current--;
  }


}
